var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.className,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.forceFileDownload()}}},[_c('flixIcon',{attrs:{"id":'download'}}),_vm._v(" "+_vm._s(_vm.$t('message.icalDownload')))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }